import { mustNotContain } from '../mustNotContain/mustNotContain';
import type { Error } from '../types';

export const mustNotContainField =
  (field: string, message?: Error['message']) =>
  (value: string, allValues: Record<string, string>): Error =>
    mustNotContain(allValues[field], message)(value);
